// DigioDigilockerKYCCallback.tsx (polling version)

import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "@/lib/axios";
import { API_BASE_URL } from "@/config";
import { useLoader } from "@/contexts/LoaderContext";

const POLL_INTERVAL_MS = 3000; // 3 seconds
const POLL_TIMEOUT_MS = 60000; // 1 minute max polling

const DigioDigilockerKYCCallback = () => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const { setLoading } = useLoader();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!sessionId || !sessionId.match(/^[a-zA-Z0-9-_]+$/)) {
      navigate("/digi-check", { replace: true });
      return;
    }

    let active = true;
    let elapsed = 0;

    const checkStatus = async () => {
      try {
        setLoading(true);
        const res = await axios.post(`${API_BASE_URL}/api/get_kyc_status/`, { session_id: sessionId });

        if (!active) return;
        if (res.data.status === "VERIFIED") {
          console.log('VERIFIED')
          setLoading(false);
          // This page runs inside the popup tab opened by MasDigioJourney.
          // The parent window is polling and will navigate itself on success.
          // Just close this popup tab so the user returns to the parent.
          if (window.opener && !window.opener.closed) {
            window.close();
          } else {
            // Not a popup (e.g. direct navigation) — navigate normally
            const nextPage = res.data?.next_page_url;
            if (nextPage) {
              navigate(nextPage, { replace: true });
            } else {
              navigate("/bank-account-authentication", { replace: true });
            }
          }
        } else if (res.data.status === "CANCELLED") {
          console.log('CANCELLED')
          navigate("/digi-check", { replace: true });
        } else if (res.data.status === "PENDING") {
          console.log('PENDING')
          alert("Please Complete Digilocker Verification. It is mandatory")
          navigate("/digi-check", { replace: true });
        } else {
          console.log('OTHER')
          alert("Please Complete Digilocker Verification. It is mandatory")
          navigate("/digi-check", { replace: true });
          // Still pending, continue polling if timeout not reached
          // elapsed += POLL_INTERVAL_MS;
          // if (elapsed < POLL_TIMEOUT_MS) {
          //   // setTimeout(checkStatus, POLL_INTERVAL_MS);
          // } else {
          //   setError("KYC verification timed out. Please try again.");
          //   setLoading(false);
          // }
        }
      } catch (err) {
        console.error("Error polling KYC status:", err);
        if (active) {
          setError("Failed to verify KYC status. Please try again.");
          setLoading(false);
        }
      }
    };

    checkStatus();

    return () => {
      active = false;
      setLoading(false);
    };
  }, [sessionId, navigate, setLoading]);

  if (error) {
    return <div className="text-red-600 text-center mt-10">{error}</div>;
  }
  return null;
};

export default DigioDigilockerKYCCallback;
